export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FilesTab.vue?vue&type=template&id=79f290e8&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/CloseProject/FilesTab.vue?vue&type=template&id=79f290e8&scoped=true
// module id = 1969
// module chunks = 31